// constants.tsx 定义常量

// export const BACKEND_API_URL:any = 'http://127.0.0.1:9069/';   // 后端API地址
export const BACKEND_API_URL: any =
  process.env.REACT_APP_ENV == 'development'
    ? window?.myUrl?.DEV_URL + '/'
    : window?.myUrl?.URL + '/' // 后端API地址

// export const BACKEND_URL = 'http://127.0.0.1:9069';
export const BACKEND_URL =
  process.env.REACT_APP_ENV == 'development'
    ? window?.myUrl?.DEV_URL
    : window?.myUrl?.URL


// export const BACKEND_URL = 'http://idxcbd.idatacoding.cn';
// export const BACKEND_API_URL:any = 'http://idxcbd.idatacoding.cn/';   // 后端API地址
